import constants from 'assets/constants';
import { Box } from '@mui/material';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

class AdComponent extends React.Component {
  componentDidMount() {
    this.loadAd();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.routeKey !== this.props.routeKey) {
      this.loadAd();
    }
  }

  loadAd = () => {
    if (window.location.hostname === 'localhost') return;

    // Wait until React has rendered the new <ins> element.
    setTimeout(() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        console.error('AdSense error:', error);
      }
    }, 0);
  };

  render() {
    const { routeKey } = this.props;

    return (
      <Box
        sx={{
          maxWidth: '100vw',
          marginLeft: -2,
          marginRight: -2,
          minWidth: 0,
          overflowX: 'hidden',
          position: 'relative',
          zIndex: 10,

          '& .adsbygoogle': {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
          },

          '& iframe': {
            maxWidth: '100% !important',
          },
        }}
      >
        <ins
          key={routeKey}
          className="adsbygoogle"
          style={{
            display: 'block',
            width: '100%',
            maxWidth: '100%',
          }}
          data-ad-client="ca-pub-9305958838449958"
          data-ad-slot="8192850596"
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </Box>
    );
  }
}

export default function RoutedAdComponent(props) {
  const location = useLocation();

  const routeKey = `${location.pathname}`;

  return (
    <AdComponent
      {...props}
      key={routeKey}
      routeKey={routeKey}
    />
  );
}